import React from 'react';
import { HANDLE_COLOR, ResizeDirection } from '../../hooks/useDraggableItem';
import { EditorItem, useEditorStore } from '../../store/editorStore';

type ResizeHandlesProps = {
  item: EditorItem;
};

export function ResizeHandles({ item }: ResizeHandlesProps) {
  const selectItem = useEditorStore((state) => state.selectItem);
  
  const handleResizeStart = (e: React.MouseEvent, direction: ResizeDirection) => {
    e.stopPropagation();
    e.preventDefault();
    
    // Ensure we have the item selected
    selectItem(item.id);
    
    console.log('ResizeHandles: starting resize in direction', direction);
    
    // Trigger the parent resize start handler via bubbling up a custom event
    const customEvent = new CustomEvent('resizeStart', { 
      bubbles: true, 
      detail: { 
        direction, 
        itemId: item.id,
        originalEvent: e // Truyền cả sự kiện gốc để lấy tọa độ chuột
      } 
    });
    
    // Dispatch event on the element that received the mouse down
    e.currentTarget.dispatchEvent(customEvent);
  };
  
  const handleStyle: React.CSSProperties = {
    position: 'absolute',
    width: '10px',
    height: '10px',
    backgroundColor: HANDLE_COLOR,
    borderRadius: '50%',
    zIndex: 20,
  };
  
  const cornerStyle: React.CSSProperties = {
    ...handleStyle,
    width: '14px',
    height: '14px',
  };
  
  return (
    <>
      {/* Corner handles */}
      <div 
        style={{ ...cornerStyle, top: '-7px', left: '-7px', cursor: 'nwse-resize' }}
        onMouseDown={(e) => handleResizeStart(e, 'nw')}
      />
      <div 
        style={{ ...cornerStyle, top: '-7px', right: '-7px', cursor: 'nesw-resize' }}
        onMouseDown={(e) => handleResizeStart(e, 'ne')}
      />
      <div 
        style={{ ...cornerStyle, bottom: '-7px', left: '-7px', cursor: 'nesw-resize' }}
        onMouseDown={(e) => handleResizeStart(e, 'sw')}
      />
      <div 
        style={{ ...cornerStyle, bottom: '-7px', right: '-7px', cursor: 'nwse-resize' }}
        onMouseDown={(e) => handleResizeStart(e, 'se')}
      />
      
      {/* Edge handles */}
      <div 
        style={{ ...handleStyle, top: '-5px', left: '50%', transform: 'translateX(-50%)', cursor: 'ns-resize' }}
        onMouseDown={(e) => handleResizeStart(e, 'n')}
      />
      <div 
        style={{ ...handleStyle, bottom: '-5px', left: '50%', transform: 'translateX(-50%)', cursor: 'ns-resize' }}
        onMouseDown={(e) => handleResizeStart(e, 's')}
      />
      <div 
        style={{ ...handleStyle, left: '-5px', top: '50%', transform: 'translateY(-50%)', cursor: 'ew-resize' }}
        onMouseDown={(e) => handleResizeStart(e, 'w')}
      />
      <div 
        style={{ ...handleStyle, right: '-5px', top: '50%', transform: 'translateY(-50%)', cursor: 'ew-resize' }}
        onMouseDown={(e) => handleResizeStart(e, 'e')}
      />
    </>
  );
} 